import { reduxForm } from 'redux-form';
import { Form } from 'forms/types';
import { PaymentFormComponent } from './PaymentFormComponent';
import { connect } from 'react-redux';
import { RegistrationSlice } from '../../state/registration/reducer';

const mapStateToFormProps = (state: RegistrationSlice) => ({
    initialValues: state.registration.settings.paymentCard,
});

export const PaymentCardForm: any = connect(mapStateToFormProps)(
    reduxForm({
        form: Form.REGISTRATION_CARD_FORM,
        destroyOnUnmount: false,
        enableReinitialize: true,
    })(PaymentFormComponent),
);
